/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Global_Toast_Success_EnabledInputs */

const es_components_credentials_global_toast_success_enabled = /** @type {(inputs: Components_Credentials_Global_Toast_Success_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credencial visible para todos los usuarios`)
};

const en_components_credentials_global_toast_success_enabled = /** @type {(inputs: Components_Credentials_Global_Toast_Success_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential visible to all users`)
};

/**
* | output |
* | --- |
* | "Credential visible to all users" |
*
* @param {Components_Credentials_Global_Toast_Success_EnabledInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_global_toast_success_enabled = /** @type {((inputs?: Components_Credentials_Global_Toast_Success_EnabledInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Global_Toast_Success_EnabledInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_global_toast_success_enabled(inputs)
	return en_components_credentials_global_toast_success_enabled(inputs)
});
export { components_credentials_global_toast_success_enabled as "components.credentials.global.toast.success_enabled" }